/**
 * Pure utility functions extracted from Lists.js for testability.
 * These functions have no React dependencies, no hooks, no JSX.
 */
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/fi';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);

export const sanitizeId = (id) => encodeURIComponent(String(id ?? ''));

export const getLocale = (application, String) => {
    const globalData = application?.globalData;
    if (!globalData || !('lang' in globalData)) {
        return 'MISSING_LANG_IN_GLOBAL_DATA';
    }
    const { strings } = globalData;
    if (!strings || !(String in strings)) {
        return `MISSING_${String}_IN_STRINGS`;
    }
    return strings[String];
};

export const makeGridDateValueGetter = () => (value) => value ? new Date(value) : null;

export const makeGridDateFormatter = (application, type = "date") => (value) => {
    if (!value) return "";
    const locale = application?.globalData?.locale?.toLowerCase() || "en";
    return dayjs(value).locale(locale).format(type === "datetime" ? "L LT" : "L");
};

export const getterTeamField = (value, row) => {
    return row?.employees ? row?.employees.map(obj => obj.name).join(',') : '';
};
